// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"bfc72886","50":"069cd768","267":"0af89f26","559":"6c1578c0","762":"721fb385","837":"bcb725ac"}[chunkId] + ".chunk.js";
};